// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"890123b6","384":"c186e022","512":"02ddf2f6","924":"b5747365"}[chunkId] + ".chunk.css";
};